import React, { useState, useRef, useEffect } from 'react'
import { useTheme, THEME_CONFIGS } from '../../utils/ThemeContext'
import { BsPaletteFill } from 'react-icons/bs'

const ThemeSwitcher = ({ isMobile = false }) => {
  const { theme, setTheme } = useTheme()
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)

  const activeConfig = THEME_CONFIGS.find(c => c.id === theme) || THEME_CONFIGS[0]

  useEffect(() => {
    const handleClickOutside = e => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  if (isMobile) {
    return (
      <div className="mobile-theme-selector">
        <span className="mobile-theme-label">Theme Variant</span>
        <div className="mobile-theme-buttons">
          {THEME_CONFIGS.map(cfg => (
            <button
              key={cfg.id}
              type="button"
              className={`mobile-theme-btn ${theme === cfg.id ? 'active' : ''}`}
              onClick={() => setTheme(cfg.id)}
              aria-label={`Switch to ${cfg.name} theme`}
            >
              <span className="theme-btn-dot" style={{ backgroundColor: cfg.previewColor }} />
              <span>{cfg.name}</span>
            </button>
          ))}
        </div>
      </div>
    )
  }

  return (
    <div className="theme-switcher-container" ref={dropdownRef}>
      <button
        type="button"
        className="theme-switcher-trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Change color theme"
        aria-expanded={isOpen}
      >
        <span
          className="theme-active-dot"
          style={{ backgroundColor: activeConfig.previewColor }}
        />
        <BsPaletteFill className="palette-icon" aria-hidden="true" />
        <span className="theme-name-text">{activeConfig.name}</span>
      </button>

      {isOpen && (
        <div className="theme-dropdown-menu" role="menu">
          <div className="theme-dropdown-header">Color Variants</div>
          {THEME_CONFIGS.map(cfg => (
            <button
              key={cfg.id}
              type="button"
              className={`theme-dropdown-item ${theme === cfg.id ? 'active' : ''}`}
              onClick={() => {
                setTheme(cfg.id)
                setIsOpen(false)
              }}
              role="menuitem"
            >
              <span
                className="theme-item-swatch"
                style={{ backgroundColor: cfg.previewColor }}
              />
              <div className="theme-item-info">
                <div className="theme-item-name">{cfg.name}</div>
                <div className="theme-item-desc">{cfg.description}</div>
              </div>
              {theme === cfg.id && <span className="theme-item-check">✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export default ThemeSwitcher
